export default __webpack_public_path__ + "58af794b40c2ee50131b865427ad3865.svg";